// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mipe-tab {\n  border-bottom: 1px solid #E2E2E2;\n}\n.mipe-tab .nav-item .nav-link {\n  font: 16px Lato;\n  letter-spacing: 0;\n  padding-bottom: 5px;\n}\n.mipe-active-tab {\n  border: 0 !important;\n  border-bottom: 3px solid var(--mipe-orange) !important;\n}\n.mipe-active-tab::after {\n  display: none;\n}\n@media only screen and (max-width: 768px) {\n.box-container-custom {\n    width: 100% !important;\n}\n}", ""]);
// Exports
module.exports = exports;
